import {
  ADD_TRUCK_FAIL,
  ADD_TRUCK_REQUEST,
  ADD_TRUCK_SUCCESS,
  DELETE_TRUCK_FAIL,
  DELETE_TRUCK_REQUEST,
  DELETE_TRUCK_SUCCESS,
  GET_SINGLE_TRUCK_FAIL,
  GET_SINGLE_TRUCK_REQUEST,
  GET_SINGLE_TRUCK_SUCCESS,
  GET_TRUCK_EMPTY_WEIGHT_LOG_FAIL,
  GET_TRUCK_EMPTY_WEIGHT_LOG_REQUEST,
  GET_TRUCK_EMPTY_WEIGHT_LOG_SUCCESS,
  GET_TRUCK_LIST,
  GET_TRUCK_LIST_FAIL,
  GET_TRUCK_LIST_SUCCESS,
  UPDATE_TRUCK_FAIL,
  UPDATE_TRUCK_REQUEST,
  UPDATE_TRUCK_SUCCESS,
} from "src/constants/types";

export const truckReducer = (state = {}, actions) => {
  switch (actions.type) {
    case GET_TRUCK_LIST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_TRUCK_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        truckList: actions.payload,
        error: "",
      };
    case GET_TRUCK_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_TRUCK_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_TRUCK_SUCCESS:
      return {
        ...state,
        loading: false,
        selected_truck: actions.payload,
      };
    case GET_SINGLE_TRUCK_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_TRUCK_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_TRUCK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_TRUCK_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_TRUCK_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_TRUCK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_TRUCK_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_TRUCK_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_TRUCK_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_TRUCK_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_TRUCK_EMPTY_WEIGHT_LOG_REQUEST:
      return {
        ...state,
        loading: true,
        empty_weight_history: null,
        error: "",
      };
    case GET_TRUCK_EMPTY_WEIGHT_LOG_SUCCESS:
      return {
        ...state,
        loading: false,
        empty_weight_history: actions.payload,
      };
    case GET_TRUCK_EMPTY_WEIGHT_LOG_FAIL:
      return {
        ...state,
        loading: false,
        empty_weight_history: null,
        error: actions.payload,
      };

    default:
      return state;
  }
};
